import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dayName',
})
export class DayNamePipe implements PipeTransform {
  transform(value: string, ...args: any[]): unknown {
    const iso = this._getISOStringFormat();
    if (!value) value = new Date().toISOString();
    const daysName = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const day = new Date(value).getDay();
    return `${daysName[day]}`;
  }

  private _getISOStringFormat(): string {
    const date: string = new Date().toISOString();
    const splitDate = date.split('T');
    return splitDate[splitDate.length - 1];
  }
}
